import { Skeleton } from "@chakra-ui/react";
import {
  type TooltipContentExpenseProps,
  TooltipExpense,
} from "@components/widgets/TooltipExpense";
import { CircleTickIcon } from "@src/components/ui-kit/Icon";
import { currency } from "@src/utils/formatters";
import cx from "classnames";

interface ExpensesProps {
  realExpenses: number;
  plannedExpenses: number;
  allItemsCompleted: boolean;
  fetching?: boolean;
}

type TooltipProps = Omit<
  TooltipContentExpenseProps,
  "plannedExpenses" | "realExpenses"
>;

export const Expenses = (props: ExpensesProps & TooltipProps) => {
  const { allItemsCompleted, ...tooltipProps } = props;

  return (
    <TooltipExpense {...tooltipProps}>
      <div className="flex items-center">
        <div className="flex flex-col">
          <Skeleton h="3" mb="1" isLoaded={!props.fetching}>
            <span
              className={cx(
                props.realExpenses > props.plannedExpenses && "text-red",
              )}
            >
              {currency.formatByWorkspace(props.realExpenses)}
            </span>
          </Skeleton>
          <Skeleton h="3" isLoaded={!props.fetching}>
            <span>{currency.formatByWorkspace(props.plannedExpenses)}</span>
          </Skeleton>
        </div>
        {allItemsCompleted && (
          <span style={{ height: 14, width: 14 }} className="ml-4 block">
            <CircleTickIcon />
          </span>
        )}
      </div>
    </TooltipExpense>
  );
};
